<div class="background">
  <div class="label-container" [class.small]="small()">
    Vergütung
    <span class="label">
      <ui-product-prices-formatter
        [price]="price()"
        [showThousandthsPlace]="showThousandthsPlace()"
        [alwaysPositiveNumber]="true"
      ></ui-product-prices-formatter>
    </span>
  </div>
</div>
